import { useCallback, useEffect, useState } from 'react';
import { getParameterByName, isNullOrEmpty } from '../assets/js/function-utils';
import ENDPOINTS from '../consts/endpoints';
import api from '../services/api';
import SessionService from '../session/session-service';

const SECRET_SEGMAIS = 'secret';
const SECRET_BROTO = 'broto';

/**
 * @Summary Trata e insere na Session as informações recebidas referentes ao SegMais e Broto
 */
const useSegMaisBroto = () => {
    const [segMaisSet, setSegMaisSet] = useState(undefined);
    const [brotoSet, setBrotoSet] = useState(undefined);

    const setSegMais = useCallback(async function (secretSegMais) {
        let chaveSegMais = null;

        if (!isNullOrEmpty(secretSegMais)) {
            try {
                const response = await api.get(ENDPOINTS.CHAVE_SEGMAIS(secretSegMais));
                chaveSegMais = response.data;
            } catch (e) {
                chaveSegMais = null;
                SessionService.clearChaveSegMais();
            }
        }
        chaveSegMais = chaveSegMais || SessionService.getChaveSegMais();
        if (chaveSegMais) {
            SessionService.setChaveSegMais(chaveSegMais);
        }

        setSegMaisSet(!!chaveSegMais);
    }, []);

    const setBroto = useCallback(async function (secretBoto) {
        let parBroto = { key: null, value: null };
        if (!isNullOrEmpty(secretBoto)) {
            try {
                const response = await api.get(ENDPOINTS.BROTO_COD_ACESSO(secretBoto));
                parBroto = response.data;
            } catch (e) {
                SessionService.clearChaveBroto();
                SessionService.clearUserBroto();
            }
        }
        parBroto.key = parBroto.key || SessionService.getChaveBroto();
        parBroto.value = parBroto.value || SessionService.getUserBroto();

        if (parBroto.key) {
            SessionService.setChaveBroto(parBroto.key);
            SessionService.setUserBroto(parBroto.value);
        }

        setBrotoSet(!!parBroto.key);
    }, []);

    // Efeito SegMais
    useEffect(() => {
        const secretSegMais = getParameterByName(SECRET_SEGMAIS);
        if (secretSegMais) {
            /** Removes the queryParam from the URL */
            window.history.pushState({}, document.title, window.location.pathname);
        }
        /** Seta o estado do SegMais */
        if (!segMaisSet) setSegMais(secretSegMais);
    }, [segMaisSet, setSegMais]);

    // Efeito Broto
    useEffect(() => {
        const secretBroto = getParameterByName(SECRET_BROTO);
        if (secretBroto) {
            /** Removes the queryParam from the URL */
            window.history.pushState({}, document.title, window.location.pathname);
        }
        /** Seta o estado do Broto */
        if (!brotoSet) setBroto(secretBroto);
    }, [brotoSet, setBroto]);

    return [segMaisSet !== undefined && brotoSet !== undefined, brotoSet, segMaisSet];
};

export default useSegMaisBroto;
